// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__32sr1","header":"MessagesList_header__3QYQs","chat":"MessagesList_chat__1s3aQ"};